const CURRENCIES = {
  usdt: "USDT",
  C4: "$C4",
};

export { CURRENCIES };
